import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-hero {
  position: relative;
  background-color: #2b0000;
  background-image: url('assets/partiu-gp-da-inglaterra/hero/bg-mobile.png');
  background-size: cover;
  background-position: center;
  padding: 32px 0 24px;
}

#partiu-gp-hero .hero-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#partiu-gp-hero .hero-content {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
}

#partiu-gp-hero .hero-logo {
  display: none;
}

#partiu-gp-hero .hero-logo-mobile {
  display: inline-block;
  width: 55%;
  max-width: 200px;
  height: auto;
  margin-bottom: 16px;
}

#partiu-gp-hero .hero-titulo {
  margin: 0 0 12px;
  line-height: 0;
}

#partiu-gp-hero .hero-titulo-img {
  display: none;
}

#partiu-gp-hero .hero-titulo-img-mobile {
  display: inline-block;
  width: 76%;
  max-width: 270px;
  height: auto;
}

#partiu-gp-hero .hero-subtitulo {
  margin: 0;
  color: #fff;
  font-family: 'SantanderHeadline';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
}

#partiu-gp-hero .hero-card {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
}

#partiu-gp-hero .hero-card-clip {
  position: relative;
  width: 100%;
  aspect-ratio: 282 / 156;
  border-radius: 16px;
  overflow: hidden;
}

#partiu-gp-hero .hero-card-img {
  display: none;
}

#partiu-gp-hero .hero-card-img-mobile {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

#partiu-gp-hero .hero-taxa {
  position: absolute;
  left: 4%;
  bottom: 6%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#partiu-gp-hero .hero-taxa-img {
  display: block;
  width: 140px;
  max-width: 42vw;
  height: auto;
}

#partiu-gp-hero .hero-taxa-legenda {
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.85);
  font-family: 'SantanderMicroText';
  font-size: 9px;
  font-weight: 400;
  white-space: nowrap;
}

#partiu-gp-hero .hero-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #EC0000;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 350ms linear;
}

#partiu-gp-hero .hero-cta:hover {
  background-color: #f14c4c;
}

#partiu-gp-hero .hero-cta-desktop {
  display: none;
}

#partiu-gp-hero .hero-cta-mobile {
  width: 100%;
  height: 48px;
  margin-top: 16px;
  max-width: 270px;
  margin-left: auto;
  margin-right: auto;
}

#partiu-gp-hero .hero-disclaimer {
  margin: 0;
  color: rgba(255, 255, 255, 0.7);
  font-family: 'SantanderMicroText';
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
}

#partiu-gp-hero .hero-disclaimer a {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: underline;
}

@media (min-width: 800px) {
  #partiu-gp-hero .hero-inner {
    max-width: 570px; 
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  #partiu-gp-hero {
    height: 490px;
    background-image: url('assets/partiu-gp-da-inglaterra/hero/bg-desktop.png');
    padding: 0;
  }

  #partiu-gp-hero .hero-inner {
    display: block;
    position: relative;
    height: 100%;
    max-width: 1440px;
    padding: 0;
  }

  /* Text column: centered as a block around x=364/1440 (25.28%) of the 1440px
     reference canvas, matching the source design exactly. */
  #partiu-gp-hero .hero-content {
    position: absolute;
    left: 0;
    top: 48px;
    width: 50.49%;
    margin-bottom: 0;
  }

  #partiu-gp-hero .hero-logo-mobile {
    display: none;
  }

  #partiu-gp-hero .hero-logo-desktop {
    display: inline-block;
    width: 49.66%;
    max-width: none;
    height: auto;
    margin-bottom: 49px;
  }

  #partiu-gp-hero .hero-titulo {
    margin-bottom: 41px;
  }

  #partiu-gp-hero .hero-titulo-img-mobile {
    display: none;
  }

  #partiu-gp-hero .hero-titulo-img-desktop {
    display: inline-block;
    width: 63.41%;
    max-width: none;
    height: auto;
  }

  #partiu-gp-hero .hero-subtitulo {
    font-size: 25px;
    line-height: 28px;
    max-width: 62%;
    margin: 0 auto;
  }

  #partiu-gp-hero .hero-cta-mobile {
    display: none;
  }

  #partiu-gp-hero .hero-cta-desktop {
    display: inline-flex;
    margin-top: 38px;
    height: 48px;
    padding: 0 32px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  }

  /* Photo card: left=730px top=28px width=670px height=343px on the 1440x410
     reference canvas -> horizontal offsets stay % (respond to the 992-1440px
     range), vertical offsets are fixed px so they don't shift when the
     section height changes. */
  #partiu-gp-hero .hero-card {
    position: absolute;
    left: 50.69%;
    top: 58px;
    width: 46.53%;
    height: 343px;
    margin-bottom: 0;
  }

  #partiu-gp-hero .hero-card-clip {
    height: 100%;
    aspect-ratio: auto;
    border-radius: 24px;
  }

  #partiu-gp-hero .hero-card-img-mobile {
    display: none;
  }

  #partiu-gp-hero .hero-card-img-desktop {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  /* Centered as a group within the card; fixed px width so it renders at a
     consistent size across the whole 992-1440px range instead of scaling
     with the card. */
  #partiu-gp-hero .hero-taxa {
    left: 50%;
    bottom: 5px;
    align-items: center;
    transform: translateX(-50%);
  }

  #partiu-gp-hero .hero-taxa-img {
    width: 147px;
    max-width: none;
    margin-bottom: -3px;
  }

  #partiu-gp-hero .hero-taxa-legenda {
    font-size: 7px;
    white-space: nowrap;
  }

  /* Positioned with a fixed top (below the card, which ends at 28+343=371px)
     so it always has room to wrap to two lines without overflowing the
     section, regardless of viewport width. */
  #partiu-gp-hero .hero-disclaimer {
    position: absolute;
    left: 50.69%;
    top: 420px;
    width: 46.53%;
  }
}
`;

export default styles;